// extracted by mini-css-extract-plugin
export var clients__list = "clients-module--clients__list--OKPfD";
export var clients__logo = "clients-module--clients__logo--6QZp0";
export var clients__logoImage = "clients-module--clients__logoImage--sLecm";
export var clients__logoWrapper = "clients-module--clients__logoWrapper--JztZa";